import { mapGetters } from "vuex"

const has_addresses = {
    methods: {
        address_of_type (owner_type, owner_id, type) {
            return this.raw_addresses.find(address => {
                return (address.owner_type === owner_type) && (address.owner_id === owner_id) && (address.address_type === type)
            }) || { id: 0, owner_type, owner_id, address_type: type }
        },
        physical_address (owner_type, owner_id) {
            return this.address_of_type(owner_type, owner_id, "physical")
        },
        mailing_address (owner_type, owner_id, distinct_mailing_address = true) {
            return this.address_of_type(owner_type, owner_id, distinct_mailing_address ? "physical" : "mailing")
        }
    },
    computed: {
        ...mapGetters(["entity_records"]),
        raw_addresses () {
            return this.entity_records("address")
        }
    }
}

export default has_addresses
